import { Table, Text } from '@mantine/core';

import { Content } from '@/core/components';

import { formatDecimal } from '@feature/utils';

interface EvaluationReportTotalTableProps {
  totalPoints: number;
  totalCategoryPoints: number;
  totalMeritPoints: number;

  title: string;
}

export function EvaluationReportTotalTable(props: EvaluationReportTotalTableProps) {
  const { title, totalPoints, totalMeritPoints, totalCategoryPoints } = props;
  return (
    <Content type="full">
      <Text
        fw="500"
        size="lg"
      >
        {title}
      </Text>
      <Table variant="vertical">
        <Table.Tbody>
          <Table.Tr>
            <Table.Th fw="500">Total</Table.Th>
            <Table.Td ta="right">{formatDecimal(totalPoints)}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Th fw="500">Total ponderat</Table.Th>
            <Table.Td ta="right">{formatDecimal(totalCategoryPoints)}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Th fw="500">
              Total ponderat cu factor de multiplicare (doar pentru acordarea gradației de merit)
            </Table.Th>
            <Table.Td ta="right">{formatDecimal(totalMeritPoints)}</Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </Content>
  );
}
